import { createAction, props } from '@ngrx/store';
import {
  AppAssessmentDocCreateRequest,
  AppAssessmentDocUpdateRequest,
  DocRenameRequest,
  DocumentDuplicateResponse,
  WorkspaceItem,
  WorkspaceMoveRequest
} from '@primatoo-ms-organization';

import { ValidateDocumentRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/ValidateDocumentRequest';
import { UpdateDocResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/UpdateDocResponse';

// APP ASSESSMENT
export const createAppAssessment = createAction('[AppAssessment] Create AppAssessment', props<{
  request: AppAssessmentDocCreateRequest
}>());
export const createAppAssessmentSuccess = createAction('[AppAssessment] Create AppAssessment Success', props<{
  id: number
}>());
export const createAppAssessmentFailed = createAction('[AppAssessment] Create AppAssessment Failed', props<{
  error: any
}>());

export const updateAppAssessment = createAction('[AppAssessment] Update App Assessment', props<{
  id: number,
  request: AppAssessmentDocUpdateRequest
}>());
export const updateAppAssessmentSuccess = createAction('[AppAssessment] Update App Assessment Success', props<{
  response: UpdateDocResponse
}>());
export const updateAppAssessmentFailed = createAction('[AppAssessment] Update App Assessment Failed', props<{
  error: any
}>());

export const renameAppAssessment = createAction('[folder] Rename App Assessment', props<{
  id: number,
  request: DocRenameRequest
}>());
export const renameAppAssessmentSuccess = createAction('[folder] Rename App Assessment Success', props<{
  id: number
}>());
export const renameAppAssessmentFailed = createAction('[folder] Rename App Assessment Failed', props<{ error: any }>());

export const publishAppAssessmentWithConfirm = createAction('[AppAssessment] Publish App Assessment with confirm', props<{
  docId: number,
  skipBack?: boolean,
  hideInfo?: boolean
}>());
export const publishAppAssessment = createAction('[AppAssessment] Publish App Assessment', props<{
  docId: number,
  skipBack?: boolean
}>());
export const publishAppAssessmentSuccess = createAction('[AppAssessment] Publish App Assessment Success');
export const publishAppAssessmentFailed = createAction('[AppAssessment] Publish App Assessment Failed', props<{
  error: any
}>());

export const moveAppAssessment = createAction('[AppAssessment] Move AppAssessment',
  props<{ id: number, workspaceMoveRequest: WorkspaceMoveRequest }>());
export const moveAppAssessmentSuccess = createAction('[AppAssessment] Move AppAssessment Success', props<{
  item: WorkspaceItem
}>());
export const moveAppAssessmentFailed = createAction('[AppAssessment] Move AppAssessment Failed', props<{
  error: any
}>());

export const duplicateAppAssessment = createAction('[AppAssessment] Duplicate AppAssessment', props<{
  id: number,
  request: AppAssessmentDocCreateRequest
}>());
export const duplicateAppAssessmentSuccess = createAction('[AppAssessment] Duplicate AppAssessment success', props<{
  response: DocumentDuplicateResponse
}>());
export const duplicateAppAssessmentFailed = createAction('[AppAssessment] Duplicate AppAssessment failed', props<{
  error: any
}>());

export const deleteAppAssessment = createAction('[AppAssessment] Delete AppAssessment', props<{ id: number }>());
export const deleteAppAssessmentSuccess = createAction('[AppAssessment] Delete AppAssessment Success');
export const deleteAppAssessmentFailed = createAction('[AppAssessment] Delete AppAssessment Failed', props<{
  error: any
}>());

export const reopenAppAssessmentWithConfirm = createAction('[AppAssessment] Reopen AppAssessment with confirm', props<{
  id: number
}>());
export const reopenAppAssessment = createAction('[AppAssessment] Reopen AppAssessment', props<{ id: number }>());
export const reopenAppAssessmentSuccess = createAction('[AppAssessment] Reopen AppAssessment Success', props<{
  id: number
}>());
export const reopenAppAssessmentFailed = createAction('[AppAssessment] Reopen AppAssessment Failed', props<{
  error: any
}>());


export const validateAppAssessmentWithConfirm = createAction('[AppAssessment] Validate document with confirm', props<{
  docId: number,
  skipBack?: boolean
}>());
export const validateAppAssessment = createAction('[AppAssessment] Validate document'
  , props<{ docId: number, request: ValidateDocumentRequest, skipBack?: boolean }>());
export const validateAppAssessmentSuccess = createAction('[AppAssessment] Validate document Success');
export const validateAppAssessmentFailed = createAction('[AppAssessment] Validate document Failed', props<{
  error: any
}>());
export const createSnapshotSuccess = createAction('[AppAssessment] Create Snapshot Success');
